export const EDITOR_DISCONNECTED_WAIT_DELAY = 'confluence.frontend.ncs.disconnected.delay.ms';
